<template>
  <div style="">
    <div class="d-flex justify-content-end mb-1">
      <b-button
        variant="primary"
        :disabled="loading"
        @click="$emit('show-form')"
      >
        <span class="text-nowrap text-capitalize">
          {{$t("actions.add")}}
        </span>
      </b-button>
    </div>
    <b-table
      class="position-relative mb-0"
      :items="groupsInfo"
      responsive
      :fields="tableColumns"
      primary-key="id"
      show-empty
      :empty-text="$t('no_record_found')"
      :busy="loading"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template #head(actions)="data">
        <span> {{ $tc(data.label, 2) }}</span>
      </template>

      <template #head(UserGroupID)="data">
        <span> {{ $tc(data.label, 2) }}</span>
      </template>

      <template #cell(actions)="data">
        <b-button
          v-if="data.item.UserID !== 'admin'"
          :id="`actions-users-${data.index}`"
          tabindex="0"
          variant="white"
          class="px-1 btn-y"
        >
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
            class="align-middle text-body"
          />
        </b-button>
        <b-popover
          :target="`actions-users-${data.index}`"
          triggers="focus"
          placement="bottom"
          custom-class="popover-p-0"
          variant="white"
        >
          <b-list-group class="m-0">
            <b-list-group-item
              v-if="$can('update', 'HanwhaDvr')"
              class="border-0"
              button
              @click="$emit('edit', data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.edit") }}
              </span>
            </b-list-group-item>

            <b-list-group-item
              v-if="$can('update', 'HanwhaDvr')"
              class="border-0"
              button
              @click="confirmDelete(data.item)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.delete") }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-popover>
        </template>
    </b-table>
  </div>
</template>

<script>
import axios from "@axios";
import { useToast } from "vue-toastification/composition";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: {
    loading: {
      type: Boolean
    },
    hanwhaDvr: {
      type: Object
    },
    groupsInfo: {
      type: Array,
      default: []
    }
  },
  setup (props, { emit }) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    const toast = useToast();

    //DATA
    const tableColumns = [
      { label: 'actions.name', key: 'actions' },
      { label: "hanwha_camera.group_id", key: "UserGroupID" },
    ];

    const trans = {
      "messages.delete.title": t("messages.delete.title"),
      "messages.delete.body": t("messages.delete.body"),
      "actions.delete": t("actions.delete"),
      "actions.cancel": t("actions.cancel"),
    }

    //METHODS
    const confirmDelete = function (group) {
      const self = this;

      this.$swal({
        title: trans["messages.delete.title"],
        text: '',
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: trans["actions.delete"],
        cancelButtonText: trans["actions.cancel"],
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          (async () => await deleteGroup(group))();
        }
      });
    }

    const deleteGroup = async (group) => {
      const params = {
        action: 'delete-group',
        id_dvr: props.hanwhaDvr.id,
        params: {
          user_group_id: group.UserGroupID
        }
      }

      await axios.post('/v1/hanwha/dvr/admin/users', params)
        .then(response => {
          const { data } = response;

          if (data.data.Response === 'Fail') {
            const { Code,Details } = data.data.Error;

            toast({
              component: ToastificationContent,
              props: {
                title: "Validation error",
                text: `${Code} - ${Details}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });

            return;
          }

          toast({
            component: ToastificationContent,
            props: {
              title: 'Ok',
              text: data.data.Response,
              icon: "CheckIcon",
              variant: "success",
            },
          });

          emit('refresh');
        });

    }

    return {
      tableColumns,

      confirmDelete,
      deleteGroup
    }
  }
}
</script>
